import Phaser from 'phaser'
import { GameScene } from './scenes/GameScene'

const BACKGROUND_COLOR = 0x1a1a2e

const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  backgroundColor: BACKGROUND_COLOR,
  antialias: true,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: '100%',
    height: '100%',
  },
  dom: {
    createContainer: true,
  },
  scene: [GameScene]
}

new Phaser.Game(gameConfig)
